import { index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;
  z-index: ${index(Options.TOPBAR)};

  width: 100%;
  min-width: 0;

  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(3)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const PeriodSelectionContainer = styled.div`
  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const MobilePeriodSelectionContainer = styled.div`
  display: none;
  width: 100%;
  justify-content: center;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: flex;
    `};
`;
